import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Download, Loader2, FileText, Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../../components/ui/button';
import { api, errMsg, fmtDateTime, downloadFile } from '../api';
import { PageHeader, Spinner, ghostBtn } from '../ui';
import SubjectResult from '../aml/SubjectResult';

export default function ReputationalCheckPage() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  const [withGraph, setWithGraph] = useState(false);

  useEffect(() => {
    let timer;
    const load = () => api.get(`/aml/checks/${id}`).then((r) => {
      setC(r.data);
      if (r.data.status === 'running') timer = setTimeout(load, 4000);
    }).catch((e) => toast.error(errMsg(e)));
    load();
    return () => clearTimeout(timer);
  }, [id]);

  if (!c) return <Spinner label="Caricamento controllo…" />;
  const running = c.status === 'running';
  const pdf = async () => {
    setBusy(true);
    try { await downloadFile(`/aml/checks/${id}/pdf${withGraph ? '?graph=true' : ''}`, `BOND_reputational_${id.slice(0, 8)}.pdf`); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader kicker={`Reputational check · ${fmtDateTime(c.created_at)}`} title={<span data-testid="aml-check-title">{c.label}</span>}>
        {c.report_id && <Link to={`/portal/report/${c.report_id}`} className={`${ghostBtn} h-10 px-4 flex items-center gap-2 text-sm`} data-testid="aml-open-report"><FileText size={15} />Report azienda</Link>}
        {running
          ? <span className={`${ghostBtn} h-10 px-4 flex items-center gap-2 text-sm opacity-50`} data-testid="aml-graph-btn-disabled"><Share2 size={15} />Grafo AML</span>
          : <Link to={`/portal/reputational/${id}/grafo`} className={`${ghostBtn} h-10 px-4 flex items-center gap-2 text-sm`} data-testid="aml-graph-btn"><Share2 size={15} />Grafo AML</Link>}
        <label className="flex items-center gap-2 text-xs text-[#8A8F97] cursor-pointer h-10" data-testid="aml-pdf-graph-label">
          <input type="checkbox" className="accent-[#D4AF37]" checked={withGraph} onChange={(e) => setWithGraph(e.target.checked)} data-testid="aml-pdf-graph" />Includi grafo nel PDF
        </label>
        <Button onClick={pdf} disabled={running || busy} className={`${ghostBtn} h-10`} data-testid="aml-pdf-btn">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <><Download size={15} className="mr-2" />Scarica PDF separato</>}
        </Button>
      </PageHeader>
      {running && <p className="text-sm text-[#8A8F97] -mt-4 mb-6 flex items-center gap-2" data-testid="aml-running-note"><Loader2 size={14} className="animate-spin text-[#D4AF37]" />Verifica in corso: può richiedere qualche minuto, la pagina si aggiorna da sola.</p>}
      {c.report_id && !running && <p className="text-xs text-[#5A5F67] -mt-4 mb-6">Per avere tutto in un solo documento, scarica il PDF BOND del report con "Includi reputational check" (con "Includi grafo" viene aggiunto anche il grafo AML).</p>}
      <div className="grid gap-4">{c.subjects.map((s, i) => <SubjectResult key={i} s={s} idx={i} checkId={id} onUpdate={setC} />)}</div>
    </div>
  );
}
